/**
 * Liste des communes d'Île-de-France (région 11) normalisées.
 * Générée depuis geo.api.gouv.fr — 1261 communes.
 * Normalisation : minuscule, sans accents, sans caractères spéciaux, tirets conservés.
 */

// ── Constante interne ──────────────────────────────────────────────────────────
const IDF_COMMUNES_RAW: string[] = [
  "abbaville-la-riviare","ableiges","ablis","ablon-sur-seine","acharcon",
  "achares","achares-la-forat","achouboulains","acouen","adainville",
  "agligny","agly","agreville","aigremont","aincourt","alancourt","alfortville",
  "allainville","amanca","ambleville","amenucourt","amerainville","amillis",
  "amponville","andelu","andilly","andrasy","andrezel","angerville",
  "angervilliers","annet-sur-marne","antony","apane","apiais-las-louvres",
  "apiais-rhus","apinay-champlatreux","apinay-sous-sanart","apinay-sur-orge",
  "apinay-sur-seine","aragny-sur-oise","arbonne-la-forat","arcueil",
  "argenteuil","argentiares","armentiares-en-brie","arnouville",
  "arnouville-las-mantes","arpajon","arrancourt","arronville","arthies",
  "arville","asniares-sur-oise","asniares-sur-seine","atampes","athis-mons",
  "atiolles","atrachy","atrapilly","attainville","aubepierre-ozouer-le-repos",
  "aubergenville","aubervilliers","auffargis","aufferville",
  "auffreville-brasseuil","augers-en-brie","aulnay-sous-bois",
  "aulnay-sur-mauldre","aulnoy","auteuil","authon-la-plaine","autouillet",
  "auvernaux","auvers-saint-georges","auvers-sur-oise","avecquemont","avernes",
  "avon","avrainville","avry-courcouronnes","avry-gragy-sur-yerre","azanville",
  "baby","bagneaux-sur-loing","bagneux","bagnolet","bahoust",
  "baillet-en-france","bailly","bailly-romainvilliers","ballainvilliers",
  "ballancourt-sur-essonne","balloy","bannost-villegagnon","banthelu","barbey",
  "barbizon","barcy","bassevelle","bathemont-la-forat","baulne","bazainville",
  "bazemont","bazoches-las-bray","bazoches-sur-guyonne","beauchamp",
  "beauchery-saint-martin","beaumont-du-gatinais","beaumont-sur-oise",
  "beautheil-saints","beauvoir","bellefontaine","bellot","belloy-en-france",
  "bennecourt","bernay-vilbert","bernes-sur-oise","berville","bessancourt",
  "beton-bazoches","beynes","bezalles","bezons","biavres","blandy","blaru",
  "blennes","bobigny","boigneville","boinville-en-mantois",
  "boinville-le-gaillard","boinvilliers","bois-colombes","bois-darcy",
  "bois-herpin","bois-le-roi","boisdon","boisemont","boissets","boissettes",
  "boissise-la-bertrand","boissise-le-roi","boissy-aux-cailles",
  "boissy-la-riviare","boissy-laillerie","boissy-le-chatel","boissy-le-cutta",
  "boissy-le-sec","boissy-mauvoisin","boissy-saint-lager","boissy-sans-avoir",
  "boissy-sous-saint-yon","boitron","bombon","bondoufle","bondy","bonnelles",
  "bonneuil-en-france","bonneuil-sur-marne","bonniares-sur-seine","bouafle",
  "bouffamont","bougival","bougligny","boulancourt","bouleurs",
  "boullay-les-troux","boulogne-billancourt","bouqueval","bouray-sur-juine",
  "bourdonna","bourg-la-reine","bourron-marlotte","boussy-saint-antoine",
  "boutervilliers","boutigny","boutigny-sur-essonne","bouville","braanaon",
  "braau","bransles","bratigny-sur-orge","braval","bray-et-la","bray-sur-seine",
  "breuil-bois-robert","breuillet","breux-jouy","briares-les-scellas",
  "brie-comte-robert","brignancourt","briis-sous-forges","brou-sur-chantereine",
  "brouy","brueil-en-vexin","brunoy","bruyares-le-chatel","bruyares-sur-oise",
  "bry-sur-marne","buc","buchelay","buhy","bullion","buno-bonnevaux","burcy",
  "bures-sur-yvette","bussiares","bussy-saint-georges","bussy-saint-martin",
  "buthiers","butry-sur-oise","cachan","caly","cannes-acluse","carnetin",
  "carriares-sous-poissy","carriares-sur-seine","cergy","cernay-la-ville",
  "cerneux","cerny","cesson","cessoy-en-montois","chailly-en-biare",
  "chailly-en-brie","chaintreaux","chalautre-la-grande","chalautre-la-petite",
  "chalifert","chalmaison","chalo-saint-mars","chalou-moulineux","chamarande",
  "chambourcy","chambry","chamigny","champagne-sur-oise","champagne-sur-seine",
  "champcenest","champcueil","champdeuil","champeaux","champigny-sur-marne",
  "champlan","champmotteux","champs-sur-marne","changis-sur-marne",
  "chanteloup-en-brie","chanteloup-les-vignes","chapet","charence",
  "charenton-le-pont","charmentray","charmont","charny","chars","chartrettes",
  "chartronges","chateau-landon","chateaubleau","chateaufort",
  "chatenay-en-france","chatenay-malabry","chatenay-sur-seine","chatenoy",
  "chatignonville","chatillon","chatillon-la-borde","chatou","chatres",
  "chauconin-neufmontiers","chauffour-las-atrachy","chauffry",
  "chaufour-las-bonniares","chaumes-en-brie","chaumontel","chaussy","chauvry",
  "chavenay","chaville","chelles","chenneviares-las-louvres",
  "chenneviares-sur-marne","chenoise-cucharmoy","chenou","cheptainville",
  "chessy","chevannes","chevilly-larue","chevrainvilliers","chevreuse",
  "chevru","chevry-cossigny","chevry-en-sereine","chilly-mazarin","choisel",
  "choisy-en-brie","choisy-le-roi","citry","civry-la-forat",
  "clairefontaine-en-yvelines","clamart","clary-en-vexin","claye-souilly",
  "clichy","clichy-sous-bois","clos-fontaine","cocherel","coigniares",
  "collagien","colombes","combs-la-ville","commeny","compans",
  "conches-sur-gondoire","conda-sainte-libiaire","conda-sur-vesgre",
  "condacourt","conflans-sainte-honorine","congerville-thionville",
  "congis-sur-tharouanne","corbeil-essonnes","corbreuse",
  "cormeilles-en-parisis","cormeilles-en-vexin","coubert","coubron",
  "couilly-pont-aux-dames","coulombs-en-valois","coulommes","coulommiers",
  "coupvray","courances","courbevoie","courcelles-en-bassae",
  "courcelles-sur-viosne","courchamp","courdimanche",
  "courdimanche-sur-essonne","courgent","courpalay","courquetaine",
  "courson-monteloup","courtacon","courtomer","courtry","coutenaon",
  "coutevroult","cracy-la-chapelle","cragy-las-meaux","crateil",
  "cravecaur-en-brie","cravent","crespiares","crisenoy","croissy-beaubourg",
  "croissy-sur-seine","crosne","crouy-sur-ourcq","cuisy","dagny",
  "dammarie-les-lys","dammartin-en-goale","dammartin-en-serve",
  "dammartin-sur-tigeaux","dampierre-en-yvelines","dampmart","dannemarie",
  "dannemois","darvault","davron","deuil-la-barre","dhuison-longueville",
  "dhuisy","diant","domont","donnemarie-dontilly","dormelles","doue","dourdan",
  "douy-la-ramae","drancy","draveil","drocourt","dugny","eaubonne",
  "ecquevilly","enghien-les-bains","ennery","ermont","esbly","esmans",
  "everly","faa-las-nemours","faremoutiers","faricy","farolles-attilly",
  "faviares","favrieux","ferriares-en-brie","feucherolles","flacourt","flagy",
  "fleury-en-biare","fleury-marogis","flexanville","flins-neuve-aglise",
  "flins-sur-seine","follainville-dennemont","fontaine-fourches",
  "fontaine-la-riviare","fontaine-le-port","fontainebleau","fontains",
  "fontenailles","fontenay-aux-roses","fontenay-en-parisis",
  "fontenay-las-briis","fontenay-le-fleury","fontenay-le-vicomte",
  "fontenay-mauvoisin","fontenay-saint-pare","fontenay-sous-bois",
  "fontenay-trasigny","forfry","forges","forges-les-bains","fosses","fouju",
  "framacourt","framainville","franconville","frapillon","fratoy","freneuse",
  "fresnes","fresnes-sur-marne","fromont","frouville","fublaines","gagny",
  "gaillon-sur-montcient","galluis","gambais","gambaiseuil","ganicourt",
  "garanciares","garches","garentreville","gargenville","garges-las-gonesse",
  "gastins","gazeran","genainville","gennevilliers","gentilly",
  "germigny-lavaque","germigny-sous-coulombs","gesvres-le-chapitre",
  "gif-sur-yvette","giremoutiers","gironville","gironville-sur-essonne",
  "gometz-la-ville","gometz-le-chatel","gommecourt","gonesse","gouaix",
  "goupilliares","gournay-sur-marne","goussainville","goussonville",
  "gouvernes","grandchamp","grandpuits-bailly-carrois","gravon","gressey",
  "gressy","gretz-armainvilliers","grez-sur-loing","grigny","grisy-les-platres",
  "grisy-suisnes","grisy-sur-seine","groslay","grosrouvre","guarard",
  "guercheville","guermantes","guernes","guerville","guibeville","guignes",
  "guigneville-sur-essonne","guillerval","guiry-en-vexin","guitrancourt",
  "gurcy-le-chatel","guyancourt","hadouville","haravilliers","hardricourt",
  "hargeville","haricy","harouville-en-vexin","haute-isle","hautefeuille",
  "herbeville","herblay-sur-seine","herma","hermeray","hodent",
  "hondevilliers","houdan","houilles","ichy","igny","isles-las-villenoy",
  "isles-les-meldeuses","issou","issy-les-moulineaux","itteville","iverny",
  "ivry-sur-seine","jablines","jagny-sous-bois","jaignes","jambville",
  "janville-sur-juine","janvry","jaulnes","joinville-le-pont","jossigny",
  "jouarre","jouars-pontchartrain","jouy-en-josas","jouy-le-chatel",
  "jouy-le-moutier","jouy-mauvoisin","jouy-sur-morin","juilly","jumeauville",
  "jutigny","juvisy-sur-orge","juziers","la boissiare-acole",
  "la brosse-montceaux","la celle-les-bordes","la celle-saint-cloud",
  "la celle-sur-morin","la chapelle-en-vexin","la chapelle-gauthier",
  "la chapelle-iger","la chapelle-la-reine","la chapelle-moutils",
  "la chapelle-rablais","la chapelle-saint-sulpice","la courneuve",
  "la croix-en-brie","la falaise","la ferta-alais","la ferta-gaucher",
  "la ferta-sous-jouarre","la forat-le-roi","la forat-sainte-croix",
  "la frette-sur-seine","la garenne-colombes","la genevraye",
  "la grande-paroisse","la haute-maison","la hauteville",
  "la houssaye-en-brie","la madeleine-sur-loing","la norville",
  "la queue-en-brie","la queue-les-yvelines","la roche-guyon","la rochette",
  "la tombe","la tratoire","la verriare","la ville-du-bois",
  "la villeneuve-en-chevrie","labbeville","lachelle","lagny-sur-marne",
  "lainville-en-vexin","larchant","lardy","lasigny","lassy",
  "latang-la-ville","laval-en-brie","lavis-saint-nom","lazle-saint-denis",
  "le bellay-en-vexin","le blanc-mesnil","le bourget","le chatelet-en-brie",
  "le chesnay-rocquencourt","le coudray-montceaux","le heaulme",
  "le kremlin-bicatre","le mae-sur-seine","le maravillois","le mesnil-amelot",
  "le mesnil-aubry","le mesnil-le-roi","le mesnil-saint-denis","le pecq",
  "le perchay","le perray-en-yvelines","le perreux-sur-marne","le pin",
  "le plessis-aux-bois","le plessis-bouchard","le plessis-feu-aussoux",
  "le plessis-gassot","le plessis-lavaque","le plessis-luzarches",
  "le plessis-pata","le plessis-placy","le plessis-robinson",
  "le plessis-travise","le port-marly","le pra-saint-gervais","le raincy",
  "le tartre-gaudran","le tertre-saint-denis","le thillay",
  "le tremblay-sur-mauldre","le val-saint-germain","le vasinet","le vaudoua",
  "les acrennes","les alluets-le-roi","les braviaires",
  "les chapelles-bourbon","les clayes-sous-bois","les essarts-le-roi",
  "les granges-le-roi","les lilas","les loges-en-josas","les marats",
  "les mesnuls","les moliares","les mureaux","les ormes-sur-voulzie",
  "les pavillons-sous-bois","les ulis","lescherolles","lesches","leudeville",
  "leudon-en-brie","leuville-sur-orge","levallois-perret","lhaa-les-roses",
  "lieusaint","limay","limeil-bravannes","limetz-villez","limoges-fourches",
  "limours","linas","lisle-adam","lisses","lissy","liverdy-en-brie",
  "livilliers","livry-gargan","livry-sur-seine","lizines","lizy-sur-ourcq",
  "lognes","lommoye","longjumeau","longnes","longperrier","longpont-sur-orge",
  "longuesse","longueville","longvilliers","lorrez-le-bocage-praaux",
  "louan-villegruis-fontaine","louveciennes","louvres","luisetaines",
  "lumigny-nesles-ormeaux","luzancy","luzarches","machault","madan",
  "maffliers","magnanville","magny-en-vexin","magny-le-hongre",
  "magny-les-hameaux","maincy","maison-rouge","maisoncelles-en-brie",
  "maisoncelles-en-gatinais","maisons-alfort","maisons-laffitte","maisse",
  "malakoff","mandres-les-roses","manerville","mantes-la-jolie",
  "mantes-la-ville","mara","marchamoret","marcilly","marcoussis","marcq",
  "mareil-en-france","mareil-le-guyon","mareil-marly","mareil-sur-mauldre",
  "mareuil-las-meaux","margency","maricourt","mariel","marines","marles-en-brie",
  "marly-la-ville","marly-le-roi","marnes-la-coquette","marobert",
  "marolles-en-beauce","marolles-en-brie","marolles-en-hurepoix",
  "marolles-sur-seine","mary-sur-marne","mary-sur-oise","massy","mauchamps",
  "maudatour-en-vexin","maule","maulette","mauperthuis","maurecourt",
  "mauregard","maurepas","may-en-multien","maziares-sur-seine",
  "mazy-sur-seine","meaux","meigneux","meilleray","melun","melz-sur-seine",
  "mennecy","menouville","menucourt","mespuits","messy","meudon",
  "meulan-en-yvelines","millemont","milly-la-forat","milon-la-chapelle",
  "misy-sur-yonne","mitry-mory","mittainville","moigny-sur-acole","moisenay",
  "moisselles","moisson","moissy-cramayel","moncourt-fromonville","mondeville",
  "mondreville","monnerville","mons-en-montois","montainville",
  "montalet-le-bois","montavrain","montceaux-las-meaux",
  "montceaux-las-provins","montchauvet","montdauphin","montenils",
  "montereau-fault-yonne","montereau-sur-le-jard","montesson","montfermeil",
  "montfort-lamaury","montga-en-goale","montgeron","montgeroult","monthyon",
  "montigny-las-cormeilles","montigny-le-bretonneux","montigny-le-guesdier",
  "montigny-lencoup","montigny-sur-loing","montlhary","montlignon",
  "montmachoux","montmagny","montmorency","montolivet","montreuil",
  "montreuil-sur-epte","montrouge","montry","montsoult","morainvilliers",
  "morangis","moret-loing-et-orvanne","morigny-champigny","mormant",
  "morsang-sur-orge","morsang-sur-seine","mortcerf","mortery","mouroux",
  "mours","mousseaux-las-bray","mousseaux-sur-seine","moussy",
  "moussy-le-neuf","moussy-le-vieux","mouy-sur-seine","mulcent",
  "nainville-les-roches","nandy","nangis","nanteau-sur-essonne",
  "nanteau-sur-lunain","nanterre","nanteuil-las-meaux","nanteuil-sur-marne",
  "nantouillet","nazel","neauphle-le-chateau","neauphle-le-vieux",
  "neauphlette","nemours","nerville-la-forat","nesles-la-vallae",
  "neufmoutiers-en-brie","neuilly-en-vexin","neuilly-plaisance",
  "neuilly-sur-marne","neuilly-sur-seine","neuville-sur-oise",
  "nogent-sur-marne","nointel","noiseau","noisiel","noisy-le-grand",
  "noisy-le-roi","noisy-le-sec","noisy-rudignon","noisy-sur-acole",
  "noisy-sur-oise","nonville","notre-dame-de-la-mer","noyen-sur-seine",
  "nozay","nucourt","obsonville","ocquerre","oinville-sur-montcient",
  "oissery","ollainville","omerville","oncy-sur-acole","orcemont","orgerus",
  "orgeval","orly","orly-sur-morin","ormesson","ormesson-sur-marne","ormoy",
  "ormoy-la-riviare","orphin","orsay","orsonville","orveau","orvilliers",
  "osmoy","osny","othis","ozoir-la-ferriare","ozouer-le-voulgis","pacy",
  "palaiseau","paley","pamfou","pantin","paray-douaville","paray-vieille-poste",
  "parigny","paris","parmain","paroy","passy-sur-seine","pazarches",
  "pecqueuse","penchard","perdreauville","persan","perthes","pierre-levae",
  "pierrelaye","piscop","plaisir","plessis-saint-benoist","poigny",
  "poigny-la-forat","poincy","poissy","poligny","pommeuse","pomponne",
  "pontault-combault","pontcarra","ponthavrard","pontoise","porcheville",
  "pracy-sur-marne","presles","presles-en-brie","pringy","provins",
  "prunay-en-yvelines","prunay-le-temple","prunay-sur-essonne",
  "puiselet-le-marais","puiseux-en-france","puiseux-pontoise","puisieux",
  "pussay","puteaux","quiers","quincy-sous-sanart","quincy-voisins","raau",
  "raizeux","rambouillet","rampillon","rebais","recloses","remauville",
  "rennemoulin","reuil-en-brie","richarville","richebourg","ris-orangis",
  "rochefort-en-yvelines","roinville","roinvilliers","roissy-en-brie",
  "roissy-en-france","rolleboise","romainville","ronquerolles","rosay",
  "rosny-sous-bois","rosny-sur-seine","rouilly","rouvres","rozay-en-brie",
  "rubelles","rueil-malmaison","rumont","rungis","rupareux","saacy-sur-marne",
  "sablonniares","saclas","saclay","sagy","sailly","saint-arnoult-en-yvelines",
  "saint-aubin","saint-augustin","saint-barthalemy","saint-brice",
  "saint-brice-sous-forat","saint-charon","saint-clair-sur-epte","saint-cloud",
  "saint-cyr-en-arthies","saint-cyr-la-riviare","saint-cyr-lacole",
  "saint-cyr-sous-dourdan","saint-cyr-sur-morin","saint-denis",
  "saint-denis-las-rebais","saint-escobille","saint-fargeau-ponthierry",
  "saint-fiacre","saint-forget","saint-germain-de-la-grange",
  "saint-germain-en-laye","saint-germain-las-arpajon",
  "saint-germain-las-corbeil","saint-germain-laval","saint-germain-laxis",
  "saint-germain-sous-doue","saint-germain-sur-acole","saint-germain-sur-morin",
  "saint-gervais","saint-gratien","saint-hilaire","saint-hilarion",
  "saint-hilliers","saint-illiers-la-ville","saint-illiers-le-bois",
  "saint-jean-de-beauregard","saint-jean-les-deux-jumeaux","saint-just-en-brie",
  "saint-lager","saint-lager-en-yvelines","saint-lambert","saint-leu-la-forat",
  "saint-loup-de-naud","saint-mammas","saint-manda","saint-mard",
  "saint-mars-vieux-maisons","saint-martin-de-brathencourt",
  "saint-martin-des-champs","saint-martin-du-boschet","saint-martin-du-tertre",
  "saint-martin-en-biare","saint-martin-la-garenne","saint-mary",
  "saint-maur-des-fossas","saint-maurice","saint-maurice-montcouronne",
  "saint-mesmes","saint-michel-sur-orge","saint-nom-la-bretache",
  "saint-ouen-en-brie","saint-ouen-laumane","saint-ouen-sur-morin",
  "saint-ouen-sur-seine","saint-pathus","saint-pierre-du-perray",
  "saint-pierre-las-nemours","saint-prix","saint-ramy-de-la-vanne",
  "saint-ramy-las-chevreuse","saint-ramy-lhonora","saint-sauveur-las-bray",
  "saint-sauveur-sur-acole","saint-simaon","saint-soupplets",
  "saint-sulpice-de-faviares","saint-thibault-des-vignes","saint-vrain",
  "saint-witz","saint-yon","sainte-aulde","sainte-colombe",
  "sainte-geneviave-des-bois","sainte-mesme","saintry-sur-seine","salins",
  "sammeron","samois-sur-seine","samoreau","sancy","sancy-las-provins",
  "sannois","santeny","santeuil","sarcelles","sartrouville",
  "saulx-les-chartreux","saulx-marchais","savigny-le-temple","savigny-sur-orge",
  "savins","savres","sceaux","seine-port","senlisse","sept-sorts","septeuil",
  "seraincourt","sermaise","serris","servon","seugy","sevran","signy-signets",
  "sigy","sivry-courtry","sognolles-en-montois","soignolles-en-brie",
  "soindres","soisy-bouy","soisy-sous-montmorency","soisy-sur-acole",
  "soisy-sur-seine","solers","sonchamp","souppes-sur-loing","sourdun",
  "souzy-la-briche","stains","sucy-en-brie","suresnes","survilliers",
  "tacoigniares","tancrou","taverny","tessancourt-sur-aubette",
  "thamaricourt","thanisy","theuville","thiais","thieux","thiverval-grignon",
  "thoiry","thomery","thorigny-sur-marne","thoury-farottes","tigeaux",
  "tigery","tilly","torcy","torfou","touquin","tournan-en-brie","tousson",
  "toussus-le-noble","trappes","tremblay-en-france","treuzy-levelay",
  "triel-sur-seine","trilbardou","trilport","trocy-en-multien","ury","us",
  "ussy-sur-marne","vaires-sur-marne","valence-en-brie","valenton",
  "valizy-villacoublay","vallangoujard","valmondois","valpuiseaux","vamars",
  "vanves","vanvilla","varennes-jarcy","varennes-sur-seine","varreddes",
  "vatheuil","vaucourtois","vaucresson","vaudherland","vaudoy-en-brie",
  "vaugrigneuse","vauhallan","vaujours","vauraal","vaux-le-panil",
  "vaux-sur-lunain","vaux-sur-seine","vayres-sur-essonne","vendrest",
  "verdelot","verneuil-latang","verneuil-sur-seine",
  "vernou-la-celle-sur-seine","vernouillet","verriares-le-buisson",
  "versailles","vert","vert-le-grand","vert-le-petit","vert-saint-denis",
  "viarmes","vicq","videlles","vieille-aglise-en-yvelines","vienne-en-arthies",
  "vieux-champagne","vignely","vigneux-sur-seine","vigny","villeba",
  "villaines-sous-bois","ville-davray","ville-saint-jacques","villebaon",
  "villebon-sur-yvette","villecerf","villeconin","villecresnes","villejuif",
  "villejust","villemarachal","villemareuil","villemer",
  "villemoisson-sur-orge","villemomble","villenauxe-la-petite",
  "villeneuve-la-garenne","villeneuve-le-comte","villeneuve-le-roi",
  "villeneuve-les-bordes","villeneuve-saint-denis","villeneuve-saint-georges",
  "villeneuve-sous-dammartin","villeneuve-sur-auvers","villeneuve-sur-bellot",
  "villennes-sur-seine","villenoy","villeparisis","villepinte","villepreux",
  "villeron","villeroy","villers-en-arthies","villetaneuse","villette",
  "villevauda","villiers-adam","villiers-en-biare","villiers-le-bacle",
  "villiers-le-bel","villiers-le-mahieu","villiers-le-sec",
  "villiers-saint-fradaric","villiers-saint-georges","villiers-sous-grez",
  "villiers-sur-marne","villiers-sur-morin","villiers-sur-orge",
  "villiers-sur-seine","villuis","vimpelles","vinantes","vincennes",
  "vincy-manauvre","viroflay","viry-chatillon","vitry-sur-seine","voinsles",
  "voisenon","voisins-le-bretonneux","voulangis","voulton","voulx",
  "vulaines-las-provins","vulaines-sur-seine","wissous","wy-dit-joli-village",
  "yables","yerres",
];

/** Alias courants qui ne sont pas dans la liste officielle des communes. */
const IDF_ALIASES: Set<string> = new Set([
  "la defense",        "paris la defense",
  // Départements — avec tirets ET avec espaces (les deux peuvent arriver après normCity)
  "hauts de seine",    "hauts-de-seine",    // 92
  "seine saint denis", "seine-saint-denis", // 93
  "val de marne",      "val-de-marne",      // 94
  "val d oise",        "val-d-oise",        // 95
  "seine et marne",    "seine-et-marne",    // 77
  "yvelines",                               // 78
  "essonne",                                // 91
  "ile de france",     "ile-de-france",     // région
  "grand paris",
  // Formes courantes absentes de l'API
  "saint-ouen",                             // 93 (renommé saint-ouen-sur-seine)
  "saint quentin en yvelines",              // 78 agglo
  "saint-quentin-en-yvelines",
]);

/** Set principal des communes IDF normalisées. */
export const IDF_SET: Set<string> = new Set(IDF_COMMUNES_RAW);

// ── Normalisation ─────────────────────────────────────────────────────────────

/**
 * Normalise un nom de ville pour comparaison :
 * - supprime les accents
 * - minuscule
 * - retire les contenus parenthétiques et les codes postaux
 * - ne conserve que lettres, espaces, tirets
 */
export function normCity(s: string): string {
  return (s || '')
    .normalize('NFD').replace(/\p{Mn}/gu, '')  // supprime tous les diacritiques
    .toLowerCase()
    .replace(/\([^)]*\)/g, ' ')       // "(92)" → " "
    .replace(/\b\d{4,5}\b/g, ' ')     // "75009" → " "
    .replace(/[^a-z \-]/g, ' ')       // tout sauf lettres/espaces/tirets
    .replace(/\s+/g, ' ')
    .trim();
}

// ── Détection IDF ─────────────────────────────────────────────────────────────

/**
 * Retourne true si la ville (après extractCity) appartient à l'Île-de-France.
 * Règle principale : si "paris" apparaît n'importe où → IDF.
 * Couvre aussi toutes les communes IDF et les noms de département/région.
 */
export function isIDF(city: string): boolean {
  const n = normCity(city);
  if (!n) return false;

  // Règle principale : "paris" n'importe où → IDF
  // Gère : "Paris", "Ville de Paris", "Paris 08-75", "Paris et périphérie"…
  if (n.includes('paris')) return true;

  // Aliases spéciaux (La Défense, noms de département/région…)
  if (IDF_ALIASES.has(n)) return true;

  // Correspondance exacte dans le set des communes
  if (IDF_SET.has(n)) return true;

  // Cas "Courbevoie - La Défense" → premier token "courbevoie"
  const firstToken = n.split(/[\s]+/)[0];
  if (firstToken && firstToken !== n && IDF_SET.has(firstToken)) return true;

  return false;
}

/** Valeur réservée pour le filtre groupé IDF. */
export const IDF_GROUP_VALUE = '__IDF__';
export const IDF_GROUP_LABEL = 'Paris et ses alentours';
